// Mock data for Avyudha.com

export const tutors = [
  {
    id: 1,
    name: "Dr. Priya Sharma",
    subject: "Mathematics",
    experience: "8 years",
    rating: 4.9,
    students: 120,
    hourlyRate: 500,
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400",
    bio: "PhD in Mathematics, specializing in competitive exam preparation",
    availability: ["Mon 10:00-12:00", "Wed 14:00-16:00", "Fri 10:00-12:00"],
    subjects: ["Class 10-12 Math", "JEE Mathematics", "NEET Mathematics"]
  },
  {
    id: 2,
    name: "Rahul Kumar",
    subject: "Physics",
    experience: "6 years",
    rating: 4.8,
    students: 95,
    hourlyRate: 450,
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400",
    bio: "IIT Graduate, Expert in JEE Physics preparation",
    availability: ["Tue 15:00-17:00", "Thu 10:00-12:00", "Sat 09:00-11:00"],
    subjects: ["Class 11-12 Physics", "JEE Physics", "Board Exam Prep"]
  },
  {
    id: 3,
    name: "Anjali Verma",
    subject: "English",
    experience: "10 years",
    rating: 4.9,
    students: 150,
    hourlyRate: 400,
    image: "https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=400",
    bio: "Masters in English Literature, IELTS & TOEFL expert",
    availability: ["Mon 14:00-16:00", "Wed 10:00-12:00", "Fri 15:00-17:00"],
    subjects: ["Spoken English", "IELTS Preparation", "Creative Writing"]
  },
  {
    id: 4,
    name: "Amit Patel",
    subject: "Chemistry",
    experience: "7 years",
    rating: 4.7,
    students: 85,
    hourlyRate: 480,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400",
    bio: "M.Sc Chemistry, specializing in Organic Chemistry",
    availability: ["Tue 10:00-12:00", "Thu 14:00-16:00", "Sat 11:00-13:00"],
    subjects: ["Class 11-12 Chemistry", "JEE Chemistry", "NEET Chemistry"]
  },
  {
    id: 5,
    name: "Sneha Reddy",
    subject: "Biology",
    experience: "5 years",
    rating: 4.8,
    students: 78,
    hourlyRate: 420,
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400",
    bio: "MBBS Doctor, Expert in NEET Biology preparation",
    availability: ["Mon 16:00-18:00", "Wed 11:00-13:00", "Fri 16:00-18:00"],
    subjects: ["Class 11-12 Biology", "NEET Biology", "Zoology & Botany"]
  },
  {
    id: 6,
    name: "Vikram Singh",
    subject: "Computer Science",
    experience: "9 years",
    rating: 4.9,
    students: 110,
    hourlyRate: 600,
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400",
    bio: "Software Engineer from Google, Coding & Programming expert",
    availability: ["Tue 18:00-20:00", "Thu 18:00-20:00", "Sat 14:00-16:00"],
    subjects: ["Python Programming", "Web Development", "Data Structures"]
  }
];

export const organizations = [
  {
    id: 1,
    name: "Brilliant Minds Academy",
    type: "Coaching Institute",
    location: "Delhi",
    students: 500,
    tutors: 25,
    image: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=400",
    courses: ["JEE Preparation", "NEET Preparation", "Board Exams"]
  },
  {
    id: 2,
    name: "Excel International School",
    type: "School",
    location: "Mumbai",
    students: 1200,
    tutors: 45,
    image: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=400",
    courses: ["CBSE Curriculum", "ICSE Curriculum", "International Boards"]
  },
  {
    id: 3,
    name: "Smart Learning Hub",
    type: "Coaching Institute",
    location: "Bangalore",
    students: 350,
    tutors: 18,
    image: "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=400",
    courses: ["Competitive Exams", "Skill Development", "Language Courses"]
  }
];

export const jobs = [
  {
    id: 1,
    title: "Mathematics Tutor Required",
    type: "Part-time",
    location: "Delhi",
    salary: "₹15,000 - ₹25,000/month",
    subjects: ["Mathematics"],
    experience: "2+ years",
    postedDate: "2 days ago",
    organization: "Brilliant Minds Academy"
  },
  {
    id: 2,
    title: "English Teacher for IELTS",
    type: "Full-time",
    location: "Mumbai",
    salary: "₹30,000 - ₹45,000/month",
    subjects: ["English", "IELTS"],
    experience: "3+ years",
    postedDate: "1 week ago",
    organization: "Global English Institute"
  },
  {
    id: 3,
    title: "Physics & Chemistry Teacher",
    type: "Full-time",
    location: "Pune",
    salary: "₹35,000 - ₹50,000/month",
    subjects: ["Physics", "Chemistry"],
    experience: "5+ years",
    postedDate: "3 days ago",
    organization: "Science Excellence Academy"
  },
  {
    id: 4,
    title: "Computer Science Tutor (Online)",
    type: "Part-time",
    location: "Remote",
    salary: "₹20,000 - ₹35,000/month",
    subjects: ["Computer Science", "Programming"],
    experience: "2+ years",
    postedDate: "5 days ago",
    organization: "CodeMaster Learning"
  }
];

export const subjects = [
  { id: 1, name: "Mathematics", icon: "Calculator", tutors: 1250, color: "bg-blue-500" },
  { id: 2, name: "Physics", icon: "Atom", tutors: 890, color: "bg-purple-500" },
  { id: 3, name: "Chemistry", icon: "FlaskConical", tutors: 780, color: "bg-green-500" },
  { id: 4, name: "Biology", icon: "Microscope", tutors: 650, color: "bg-teal-500" },
  { id: 5, name: "English", icon: "BookOpen", tutors: 1100, color: "bg-orange-500" },
  { id: 6, name: "Computer Science", icon: "Laptop", tutors: 950, color: "bg-indigo-500" },
  { id: 7, name: "History", icon: "Landmark", tutors: 420, color: "bg-yellow-600" },
  { id: 8, name: "Geography", icon: "Globe", tutors: 380, color: "bg-cyan-500" }
];

export const testimonials = [
  {
    id: 1,
    name: "Ravi Mehta",
    role: "JEE Aspirant",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200",
    rating: 5,
    text: "Avyudha helped me find the perfect Math tutor for JEE preparation. The platform is easy to use and the tutors are highly qualified. I improved my score by 40%!"
  },
  {
    id: 2,
    name: "Priya Gupta",
    role: "Class 12 Student",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200",
    rating: 5,
    text: "Amazing experience! I found multiple tutors for different subjects. The scheduling feature made it so convenient to book classes according to my availability."
  },
  {
    id: 3,
    name: "Arun Kumar",
    role: "Parent",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200",
    rating: 5,
    text: "As a parent, I was looking for reliable tutors for my daughter. Avyudha provided verified and experienced tutors. Highly recommend this platform!"
  }
];

export const howItWorksSteps = [
  {
    id: 1,
    title: "Create Your Profile",
    description: "Sign up and tell us about your learning needs, subjects, and preferred schedule",
    icon: "UserPlus"
  },
  {
    id: 2,
    title: "Browse Tutors",
    description: "Search from our database of 7000+ verified tutors based on subject, experience, and ratings",
    icon: "Search"
  },
  {
    id: 3,
    title: "Book a Session",
    description: "Choose available time slots and schedule your online or offline tutoring session",
    icon: "Calendar"
  },
  {
    id: 4,
    title: "Start Learning",
    description: "Join your session and start your learning journey with expert guidance",
    icon: "GraduationCap"
  }
];

export const stats = [
  { label: "Tutors", value: "7,000+", icon: "Users" },
  { label: "Job Postings", value: "20,000+", icon: "Briefcase" },
  { label: "Institutes", value: "100+", icon: "School" },
  { label: "Students Served", value: "50,000+", icon: "GraduationCap" }
];
